import { Box } from '@mui/material';

export default function Logo({ sx }) {
  return <Box component='img' src='/Avid_Logo_(R)lr_white.png' sx={{ height: 40, ...sx }} />;
}
